import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class quizzesList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected quizImportTooltip!: infoButton_template;

    protected initPartial() {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.quizImportTooltip = new infoButton_template("quizImportTooltip", this.getTemplateViewModel(), this.caller);
        this.quizImportTooltip.setTitle("Import Quizzes Help");
        this.quizImportTooltip.setContent(`
            <div>
                <p>Create a CSV file with this exact header row:</p>
                <p><b>quiz, brands, question, options, correct, rationale, difficulty, basis</b></p>
                <ul class="import-guidance-tooltip-list">
                    <li><b>quiz</b>: required quiz title. Rows with the same quiz title are grouped into one quiz.</li>
                    <li><b>brands</b>: optional pipe-separated brand short names, for example <b>brand-a|brand-b</b>. Empty uses the current brand.</li>
                    <li><b>question</b>: required question text.</li>
                    <li><b>options</b>: required pipe-separated option text, for example <b>Option A|Option B|Option C</b>.</li>
                    <li><b>correct</b>: required. Must match one option exactly.</li>
                    <li><b>rationale</b>: required rationale text.</li>
                    <li><b>difficulty</b>: required. Use <b>easy</b>, <b>medium</b>, or <b>hard</b>. Values are case-insensitive.</li>
                    <li><b>basis</b>: optional. Use <b>article</b> or <b>topic</b>. Empty defaults to <b>topic</b>. Values are case-insensitive.</li>
                </ul>
                <p>Save the file as CSV before uploading.</p>
            </div>
        `);
    }

    protected getTemplateHtml(): string {
        return `
            <div class="list-header w-justify">
                <div class="w-left">
                    <button data-bind="event: { click: onClickAddQuiz }" class="btn secondary icon i-add" type="button">Create Quiz</button>
                    <button data-bind="event: { click: onClickShowQuizImport }" class="btn secondary icon i-upload" style="margin-left: 10px;" type="button">Import Quizzes</button>
                </div>
                <div class="w-center">
                    <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                        <div class="w-search-feild icon i-search2">
                            <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                            <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                            <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                            <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                        </div>
                    </div>
                </div>
                <div class="w-right">
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'numberOfQuestions') }, css: { 'list-sort-desc': orderByAndDirection()=='numberOfQuestions_DESC', 'list-sort-asc': orderByAndDirection()=='numberOfQuestions_ASC' }">Number of Questions</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'numberOfRespondents') }, css: { 'list-sort-desc': orderByAndDirection()=='numberOfRespondents_DESC', 'list-sort-asc': orderByAndDirection()=='numberOfRespondents_ASC' }">Number of Respondents</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: quizzes">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: title"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: numberOfQuestions"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: numberOfRespondents"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateCreated"></span></a></td>
                        </tr>
                    </tbody>
                </table>
                <div data-bind="visible: listIsEmpty" class="empty-list">No quizzes found.</div>
            </div>

            <div id="quiz-import-dialog" class="w-lightbox light-theme quiz-import-lightbox" data-bind="css: { 'is-visible': isQuizImportModalVisible }">
                <div id="quiz-import-dialog-content" class="lightbox-content website-user-delete">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Import Quizzes</h3>
                            <button type="button" data-bind="event: { click: onClickCancelQuizImport }" class="close-button icon i-close-2"></button>
                        </div>
                        <div class="form-body scroll">
                            <div class="form-group">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <label class="form-label">CSV Import Guidance</label>
                                    <div class="w-tooltips-adv pos-bottom-right import-guidance-tooltip">
                                        ${this.quizImportTooltip.getHtmlBuild()}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">CSV File</label>
                                <div class="import-file-actions">
                                    <div class="dropzone needsclick dz-clickable"
                                         data-bind="css: { 'is-drag-over': isQuizImportDragOver, 'has-file': quizImportFileName },
                                                    event: { dragover: onQuizImportDragOver, dragleave: onQuizImportDragLeave, drop: onQuizImportDrop }">
                                        <input id="quiz-import-csv-file" class="input-file-btn icon" name="csvFile" type="file" accept=".csv,text/csv" data-bind="css: { 'i-upload': !quizImportFileName(), 'i-file': !!quizImportFileName() }, event: { change: onQuizImportFileSelected }">
                                        <p class="form-text" data-bind="text: quizImportFileName() ? quizImportFileName() : 'Drag and drop a CSV file here, or click to choose one.'"></p>
                                    </div>
                                    <button type="button" data-bind="visible: quizImportFileName, event: { click: onClickRemoveQuizImportFile }" class="btn border icon i-delete import-file-remove">Remove file</button>
                                </div>
                                <p class="form-text" data-bind="visible: quizImportValidating">Validating CSV file...</p>
                                <p class="form-text alert-success import-validation-success" data-bind="visible: quizImportIsValid">CSV file is valid.</p>
                                <div class="import-validation-errors" data-bind="visible: quizImportValidationErrors().length > 0">
                                    <ul data-bind="foreach: quizImportValidationErrors">
                                        <li class="form-text alert-error" data-bind="text: $data"></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="form-group" data-bind="visible: quizImportInProgress">
                                <img src="/assets/images/loading-2.svg" alt="" class="export-loading-spinner" data-bind="visible: quizImportInProgress">
                                <p class="form-text">Importing quizzes...</p>
                            </div>
                            <div class="form-group">
                                <p class="form-text" style="font-weight: 600;">There is a delay for the quizzes creation after the quizzes import is completed.</p>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCancelQuizImport }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickConfirmQuizImport }, disable: !quizImportFileName() || quizImportValidating() || !quizImportIsValid() || quizImportInProgress()" class="btn highlight">Import Quizzes</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "quizzesList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            quizzes: ko.observableArray([]),
            orderBy: ko.observable("dateCreated"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateCreated_DESC"),
            listIsEmpty: ko.observable(false),
            isQuizImportModalVisible: ko.observable(false),
            isQuizImportDragOver: ko.observable(false),
            quizImportFileName: ko.observable(''),
            quizImportInProgress: ko.observable(false),
            quizImportValidating: ko.observable(false),
            quizImportIsValid: ko.observable(true),
            quizImportValidationErrors: ko.observableArray([]),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickAddQuiz: function (data, event) {
                self.caller.addQuiz();
            },
            onClickShowQuizImport: function () {
                self.caller.showQuizImportModal();
            },
            onQuizImportFileSelected: function (data, event) {
                self.caller.selectQuizImportFile(event.target.files && event.target.files[0] ? event.target.files[0] : null);
            },
            onQuizImportDragOver: function (data, event) {
                event.preventDefault();
                self.getTemplateViewModel().isQuizImportDragOver(true);
            },
            onQuizImportDragLeave: function (data, event) {
                event.preventDefault();
                self.getTemplateViewModel().isQuizImportDragOver(false);
            },
            onQuizImportDrop: function (data, event) {
                event.preventDefault();
                self.getTemplateViewModel().isQuizImportDragOver(false);
                const dropEvent = event.originalEvent || event;
                self.caller.selectQuizImportFile(dropEvent.dataTransfer.files && dropEvent.dataTransfer.files[0] ? dropEvent.dataTransfer.files[0] : null);
            },
            onClickRemoveQuizImportFile: function () {
                self.caller.removeQuizImportFile();
            },
            onClickConfirmQuizImport: function () {
                self.caller.importQuizzes();
            },
            onClickCancelQuizImport: function () {
                self.caller.cancelQuizImport();
            },
            onClickView: function (quiz, event) {
                self.caller.viewQuiz(quiz.id);
            }
        };
    }

    public setQuizzes(quizzes): void {
        let quizzesToSet = [];
        let brandId = this.caller.getBrandId();

        for (let quiz of (quizzes || [])) {
            quizzesToSet.push({
                id: quiz.id,
                emakiView: `/brand/${brandId}/categorization/quizzes/view/${quiz.id}`,
                title: quiz.title,
                numberOfQuestions: quiz.numberOfQuestions,
                numberOfRespondents: quiz.numberOfRespondents,
                dateCreated: quiz.dateCreated
            });
        }

        this.getTemplateViewModel().quizzes(quizzesToSet);
        this.getTemplateViewModel().listIsEmpty(quizzesToSet.length === 0);
    }

    public setResultInfo(nbResults, nbPages, execTime) {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    protected onClickReorder(value, data, event): any {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.quizzesListReorder();
    }

    public getViewModelForRequest() {
        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword
            }
        };
    }

    public setQuizImportModalVisible(isVisible: boolean) {
        this.getTemplateViewModel().isQuizImportModalVisible(isVisible);
    }

    public setQuizImportDragOver(isDragOver: boolean) {
        this.getTemplateViewModel().isQuizImportDragOver(isDragOver);
    }

    public setQuizImportFileName(fileName: string) {
        this.getTemplateViewModel().quizImportFileName(fileName);
    }

    public setQuizImportInProgress(isImporting: boolean) {
        this.getTemplateViewModel().quizImportInProgress(isImporting);
    }

    public setQuizImportValidationState(isValidating: boolean, isValid: boolean, errors: Array<string> = []) {
        this.getTemplateViewModel().quizImportValidating(isValidating);
        this.getTemplateViewModel().quizImportIsValid(isValid);
        this.getTemplateViewModel().quizImportValidationErrors(errors);
    }

    public isQuizImportValid(): boolean {
        return this.getTemplateViewModel().quizImportIsValid();
    }

    public clearQuizImportFile() {
        this.setQuizImportDragOver(false);
        this.setQuizImportFileName('');
        this.setQuizImportValidationState(false, false);

        const fileInput = document.getElementById('quiz-import-csv-file') as HTMLInputElement;
        if (fileInput) {
            fileInput.value = '';
        }
    }

    public resetQuizImportForm() {
        this.clearQuizImportFile();
        this.setQuizImportInProgress(false);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/quizzesList_template.ts